<template>
    <div>
        <v-server-table :name="tableName" :ref="tableName" url="/jsa/list" :columns="columns" :options="options">

            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                <div class="clearfix d-md-none d-block"></div>

                <div v-if="allowFilterSaving" class="float-left mr-1">
                    <user-filters ref="jsaSavedFilters" assetType="Jsa" :filterKey="filterKey" @saving="setUserFilterData" @show="setUserFilterData"></user-filters>
                </div>

                <div class="float-left">
                    <table-filters-2 ref="jsaTableFilters"
                        filterUrl="/jsa/filters"
                        v-bind:filters="filters"
                        :emptyFilters="filterDefs"
                        :filterKey="filterKey"
                        @filtersChanged="refreshTableData"
                        @filtersCleared="filtersCleared"
                        v-show="!dashboardFilters">
                        <template slot-scope="slotProps">
                            <div class="d-inline-block">
                                <date-range-selector buttonTitle="JSA Date" v-model="slotProps.filters['jsa_records.jsa_date']" />
                            </div>
                            <div class="d-inline-block" style="width: 250px;" v-if="this.assetType !== 'Jobsite'">
                                <jobsite-select :forFilters="true" :selectedValues="slotProps.filters['jsa_records.JobsiteId']" v-on:vselected="((data) => { slotProps.filters['jsa_records.JobsiteId'] = data || {};  })" />
                            </div>
                            <div class="d-inline-block">
                                <multi-select v-model="slotProps.filters['jsa_records.status_id']" :btnLabel="(values) => ('Statuses ('+values.length+')')" :selectOptions="slotProps.filterData.statuses" :options="{multi: true}"></multi-select>
                            </div>
                            <div class="d-inline-block" style="width: 250px;">
                                <user-select :forFilters="true" :selectedValues="slotProps.filters['jsa_records.UserId']" v-on:vuselected="((data) => { slotProps.filters['jsa_records.UserId'] = data || {};  })" placeholder="Owner"></user-select>
                            </div>
                            <div class="d-inline-block">
                                <multi-select
                                    v-model="slotProps.filters['jsa_records.jsa_template_id']"
                                    :btnLabel="(values) => ('Template ('+values.length+')')"
                                    :selectOptions="slotProps.filterData.templates"
                                    :options="{multi: true}"></multi-select>
                            </div>
                        </template>
                    </table-filters-2>
                </div>

                <button type="button" class="btn btn-outline-success ml-2" v-on:click="exportTable()" :disabled="exportingTable">
                    <template v-if="!exportingTable"><i class="fa fa-file-excel-o"></i> Export</template>
                    <template v-else><i class="fa fa-circle-o-notch fa-spin"></i> Exporting</template>
                </button>

                <div class="clearfix d-md-none d-block"></div>
            </div>

            <template slot="jsa_id" slot-scope="props">
                <router-link v-if="props.row.status_context != 'InProgress'" :to="`/jsa/view/${props.row.jsa_id}`" title="View" class="btn btn-xs btn-secondary">
                    View
                </router-link>

                 <router-link v-else :to="`/jsa/edit/${props.row.jsa_id}`" title="View" class="btn btn-xs btn-light">
                    <i class="fa fa-edit"></i> Edit
                </router-link>
            </template>
            <router-link slot="jsa_name" slot-scope="props" :to="`/jsa/view/${props.row.jsa_id}`" >
                {{ props.row.jsa_name }}
            </router-link>

            <template slot="status_name" slot-scope="props">
                <span :class="`badge badge-${props.row.status_color}`">{{ props.row.status_name }}</span>
            </template>

            <template slot="LastName" slot-scope="props">
                <user-name :user="props.row" />
            </template>

            <template slot="jsa_date" slot-scope="props">
                {{ props.row.jsa_date | moment("MM/DD/YYYY") }}
            </template>

           <router-link slot="JobsiteName" slot-scope="props" :to="`/jobsites/view/${props.row.JobsiteId}`" >
                <span v-if="props.row.JobsiteNumber">{{ props.row.JobsiteNumber }} - </span>{{ props.row.JobsiteName }}
            </router-link>

        </v-server-table>
    </div>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';
    import customVTColDropdown from '@/components/vue-tables-2/CustomColumnDropdown';

    export default {
        props: {
            assetType: {
                type: String,
                default: null,
            },

            assetId: {
                //type: Number,
                default: null,
            },

            filterId: {
                type: Number,
                default: null,
            },

            allowFilterSaving: {
                //type: Boolean,
                default: false,
            },

            dashboardFilters: {
                type: Object,
                default(){
                    return null;
                },
            },

            tableConfig: {
                type: Object,
                default(){
                    return null;
                },
            },
        },

        data: function() {
            return {
                exportingTable: false,
                tableName: "JsaTable",
                columns: ['jsa_id', 'jsa_name', 'status_name', 'step_count', 'LastName', 'jsa_date', 'JobsiteName'],

                filterDefs: {
                    'jsa_records.status_id': [],
                    'jsa_records.jsa_date' : '',
                    'jsa_records.JobsiteId' : {},
                    'jsa_records.UserId': {},
                    'jsa_records.jsa_template_id': [],
                },

                filterKey: 'jsaFilters',
            }
        },

        watch: {
            appliedFilter(newVal, oldVal){
                //Call the helper
                this.checkForAppliedFilter();
            },
        },

        computed: {
            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },

            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },

            options(){
                return {
                    headings: {
                        jsa_id: 'View',
                        jsa_name: 'Name',
                        status_name: 'Status',
                        step_count: '# of Steps',
                        LastName: 'Owner',
                        jsa_date: 'Date',
                        JobsiteName: 'Jobsite'
                    },
                    saveState: true,
                    columnsDropdown: customVTColDropdown,
                    visibleColumns: this.$root.getVisibleColumnsFromState(this.tableName),
                    orderBy: {
                        ascending: false,
                        column: 'jsa_date',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('jsaListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Set the filters
                        data.filters = (this.dashboardFilters ? filterExtractor.extractFilters(this.dashboardFilters) : filterExtractor.extractFilters(this.filters));

                        //Include the asset
                        data.assetType = this.assetType
                        data.assetId = this.assetId

                        //Send it
                        return data;
                    },
                    uniqueKey: 'jsa_records.jsa_id',
                }
            },
        },

        methods: {

            refreshTableData(filters) {
                //Set the data
                this.$refs.JsaTable.setPage(1);
                //this.$refs.JsaTable.getData();
            },

            filtersCleared(){
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.jsaTableFilters.resetColVis(this.$refs.JsaTable);
            },

            setUserFilterData(){
                //Call the Helper
                this.$refs.jsaSavedFilters.setFilterParams(this.$refs.JsaTable);
            },

            checkForAppliedFilter(){
                //Check if
                if(!this.allowFilterSaving || !this.appliedFilter)
                {
                    return;
                }

                //Call the helper
                this.$refs.jsaTableFilters.setColVis(this.$refs.JsaTable);
            },

            exportTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the Filters
                var filters = filterExtractor.extractFilters(this.filters);

                //Build the payload
                var payload = {
                    filters: filters,
                    query: (this.$refs.JsaTable.getRequestParams()).query,
                    orderBy: this.$refs.JsaTable.options.orderBy.column,
                    ascending: this.$refs.JsaTable.options.orderBy.ascending,
                    table: 'jsaTable',
                    columns: this.$refs.JsaTable.columns,
                    visible_columns: this.$root.getVisibleColumnsFromState(this.tableName),
                    export: true,
                    //headings: this.$refs.JsaTable.options.headings,
                };

                //Send it
                this.$http.get('/jsa/list', payload)
                    .then(response => {
                        //Open the new window
                        window.open(response.data);

                        //Alert the User
                        this.$toastr.success('Export Complete');
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.error(err.response.data, 'Failed to Export Inspections');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },
        },

        mounted(){
            //Check for Staring Filters
            if(!this.dashboardFilters)
            {
                //Check for a saved filter
                this.checkForAppliedFilter();

                //Check for Filter ID
                if(this.filterId)
                {
                    this.$refs.jsaSavedFilters.setSavedFilter(this.filterId);
                }
            }

            //Check for Table Config
            if(this.tableConfig)
            {
                //Set it
                this.$refs.jsaTableFilters.setColVisFromSavedFilter(this.$refs.JsaTable, this.tableConfig);
            }
        }
    }
</script>
